export default __webpack_public_path__ + "bf654efdd625b5f051b991c03139e156.svg";